import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[mcWorkspaceFilesUserStatusListWarning]'
})
export class WorkspaceFilesUserStatusListWarningDirective {
  constructor(public templateRef: TemplateRef<any>) { }
}
